import Vue from 'vue';
/*import ElementUI from 'element-ui';
Vue.use(ElementUI);
*/
// import moment from 'moment'
import {Message} from 'element-ui';

// import VueI18n from 'vue-i18n'
import {rootImgUrl, rootImgUrl_qiufeng} from '../service/rootUrl'
// import html2canvas from 'html2canvas'
// import {Canvas2Image} from '../../static/lib/canvas2image'
// /**
//  加密
//  **/
// import aesjs from "aes-js"

// Vue.use(VueI18n);
// export const i18n = new VueI18n({
//   locale: window.localStorage.lang ? JSON.parse(window.localStorage.lang).lang : "zh-CN",    // 语言标识
//   messages: {
//     'zh-CN': require('../../src/lang/zh'),   // 中文语言包
//     'en-US': require('../../src/lang/en')    // 英文语言包
//   },
// });

/**
 * 公共变量
 */
export const othersContent = {
  colors: ['#93bcf2', '#b8e4be', '#fbc05e', '#f5aaaa', '#fbe083', '#d9a1eb',
    '#fc898f', '#949dd4', '#bdaddb', '88dbf3'],
  a: "如此添加",
};
/**
 * 存储localStorage
 */
export const setLocal = (name, content) => {
  if (!name) return;
  if (typeof content !== 'string') {
    content = JSON.stringify(content);
  }
  window.localStorage.setItem(name, content);
};

/**
 * 获取localStorage
 */
export const getLocal = name => {
  if (!name) return;
  if (!window.localStorage.getItem(name)) return "";
  try {
    return JSON.parse(window.localStorage.getItem(name));
  } catch (error) {
    // console.log(error);
    return window.localStorage.getItem(name);
  }

};

/**
 * 删除localStorage
 */
export const removeLocal = name => {
  if (!name) return;
  window.localStorage.removeItem(name);
};

/**
 * 比较2个数组是否相同
 */
export const arrayIsEquals = (arr1,arr2) => {
  arr1.sort();
  arr2.sort();
  if(JSON.stringify(arr1)==JSON.stringify(arr2))return true;
  else return false;
};

/**
 * 获取字符长度,用于图片生成文字
 */
export const getBLen= str => {
  var len = 0;
  for (var i=0; i<str.length; i++) {
    if (str.charCodeAt(i)>127 || str.charCodeAt(i)==94 || str.charCodeAt(i)==87) {
      len += 2;
    } else if((str.charCodeAt(i)>=65&&str.charCodeAt(i)<=90)){
      len += 1.3;
    }else{
      len ++;
    }
  }
  if(len==1)len=1.8;
  if(len==1.3)len=2;
  // console.log(len);
  return len;
};
/**
 * 获取style样式
 */
export const getStyle = (element, attr, NumberMode = 'int') => {
  let target;
  // scrollTop 获取方式不同，没有它不属于style，而且只有document.body才能用
  if (attr === 'scrollTop') {
    target = element.scrollTop;
  } else if (element.currentStyle) {
    target = element.currentStyle[attr];
  } else {
    target = document.defaultView.getComputedStyle(element, null)[attr];
  }
  //在获取 opactiy 时需要获取小数 parseFloat
  return NumberMode == 'float' ? parseFloat(target) : parseInt(target);
};
/**
 * base64转文件
 */
export const convertBase64UrlToBlob = function (urlData) {
  var bytes = window.atob(urlData.split(',')[1]);        //去掉url的头，并转换为byte

  //处理异常,将ascii码小于0的转换为大于0
  var ab = new ArrayBuffer(bytes.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < bytes.length; i++) {
    ia[i] = bytes.charCodeAt(i);
  }
  return new Blob([ab], {type: 'image/png'});
};
/**
 * bolb转base64
 */
export const blobToDataURL = function (blob, callback) {
  var a = new FileReader();
  a.onload = function (e) { callback(e.target.result); }
  a.readAsDataURL(blob);
}
/**
 * 上传图片返回数据需要加上此url
 */
import UploadPdf from '../../static/img/pdf1.png'
export const updataUrl = (data,options) => {
  let canhsu=options||{};
  if(!data) return "";
  else if (data.includes("/static/img/PDFshow.104dc7b.jpg")) return data;
  else if (data && data.includes("data:image")) return data;
  else if (data && data.split(".").pop(1).toUpperCase()=="PDF"&&!canhsu.pdfNeedHttp) return UploadPdf;
  else if (data && !data.includes("http://")) return rootImgUrl + data;
  else return "";
};
/**
 * 查询返回数据需要加上此url
 */
export const queryDataUrl = (data) => {
  if (data && !data.includes("http://")) return rootImgUrl_qiufeng + data;
  else return "";
};
export const imgHeightWidth = function (url, classname) {
  return new Promise((resolve, reject) => {
    let name = 'c' + classname;
    $("body").append('<img src="' + url + '" alt="" style="display: none" class="' + name + ' createimg">');
    $('.' + name).on("load", function () {
      let obj = {width: $(this).width(), height: $(this).height()};
      // console.log(obj);
      $(this).remove();
      resolve(obj);
    });
  })
};
/**
 * log_
 */
export const log_ = (data, number) => {
  let arr = ['demo', 'highQuery'];
  if (arr.includes(number)) {
    // console.log(data);
  }
};
/**
 * 锁定滚动,适合dialog,暂时不用
 */
export const isScoll_ = (bol) => {
  if (bol) $("html").css({
    "overflow-y": "hidden",
  });
  else $("html").css({
    "overflow-y": "visible",
  });
};
/**
 * 锁定滚动,适合待定
 */
export const daiding_ = (bol) => {

};

export const compareKeyMergeArr = function (resultArr, newArr, key) {
  newArr.map((newItem) => {
    let filterArr = resultArr.filter(function (resultItem) {
      return resultItem[key] == newItem[key];
    });
    if (filterArr.length == 0) {
      resultArr.push(newItem);
    }
  });
  // console.log(JSON.stringify(resultArr));
  return resultArr;
};

export const getQueryObject = function (url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
};

export const $_GET = (function () {
  var url = window.document.location.href.toString();
  var u = url.split("?");
  if (typeof(u[1]) == "string") {
    if (u[1].indexOf('#') != -1) {
      u = u[1].split("#");
      u = u[0].split("&");
    } else {
      u = u[1].split("&");
    }
    var get = {};
    for (var i in u) {
      var j = u[i].split("=");
      get[j[0]] = j[1];
    }
    return get;
  } else {
    return {};
  }
})();
/**
 * 续展绝限,可续展状态
 */
/*根据日期推算续展绝限,可续展状态*/
export const extensionDiscription = (date) => {
  let validdate = moment(date).format("YYYY-MM-DD");
  let today = moment(new Date()).format("YYYY-MM-DD");
  let oneYearBefore = moment(date).subtract(1, 'years').calendar();
  oneYearBefore = moment(oneYearBefore).format("YYYY-MM-DD");
  let sixMonthAfter = moment(date).add(6, 'months').calendar();
  sixMonthAfter = moment(sixMonthAfter).format("YYYY-MM-DD");
  let status = "";
  if (today < oneYearBefore) {
    status = "预定续展";
  } else if (today >= oneYearBefore && today <= validdate) {
    status = "正常续展";
  } else if (today > validdate && today <= sixMonthAfter) {
    status = "宽展期续展";
  } else if (today > sixMonthAfter) {
    status = "不可续展";
  }
  if (!date) {
    validdate = oneYearBefore = sixMonthAfter = status = "";
  }
  return {
    validdate,//专用权到期日
    oneYearBefore,//专用权到期日一年前
    sixMonthAfter,//专用权到日半年后
    status,//是否可续展
    today,//今天
  };
};

/**
 * 上传文件校验
 */
/*
        let bol = this.formatCheck({
          file: file,
          suffix:["JPG","PNG","GIF","TIFF"],
          size:"2048000",
        });
除了file,其他都是要求
*/
export const formatCheck = function (obj) {//传参对象,
  if (!obj.suffix) {
    obj.suffix = ["JPG","JPEG","PNG", "GIF", "TIFF","JPEG","BMP","PDF"];
  }
  if (!obj.size) {
    obj.size = 2048000;
  }
  var suffix = obj.file.name.split(".").pop().toUpperCase();
  let isHave = obj.suffix.includes(suffix);
  
  if (!isHave) {
    this.$message('图片格式错误');
    return false;
  }
  if (obj.file.size > obj.size) {
    this.$message("图片尺寸过大");
    return false;
  }
  return true;
};

export const formatCheck2 = function (obj) {//传参对象,
  if (!obj.suffix) {
    obj.suffix = ["JPG", "PNG", "GIF", "TIFF"];
  }
  if (!obj.size) {
    obj.size = 2048000;
  }
  var suffix = obj.file.name.split(".").pop().toUpperCase();
  let isHave = obj.suffix.includes(suffix);
  if (!isHave) {
    this.$message(this.$t("query_lang.Image_format_error"));
    return false;
  }
  if (obj.file.size > obj.size) {
    this.$message(this.$t("query_lang.The_file_is_too_large"));
    return false;
  }
  if (obj.pixel) {
    console.log("if");
    imgHeightWidth(obj.file.url, "ceshipixel")
      .then((data) => {
        if (data.height < obj.pixel.heigthMin || data.height > obj.pixel.heightMax) {
          this.$message("Image resolution error.");
          return false;
        }
        if (data.width < obj.pixel.widthMin || data.width > obj.pixel.widthMax) {
          this.$message("Image resolution error.");
          return false;
        }
        return true;
      })
  } else {
    console.log("else");
    return true;
  }

  /*
  this.formatCheck({
          file: file,
          suffix: ["JPG"],
          size: 204800,
          pixel: {
            heightMax: 1500,
            widthMax: 1500,
            heigthMin: 400,
            widthMin: 400,
          }
        });
  */
};
/**
 *前端翻译
 * **/
export const feTranslate = function (str) {
  if(!str)return str;
  str = str.trim();
  i18n.locale = JSON.parse(window.localStorage.lang).lang;//再来一下,才稳定
  let result = "";
  switch (str) {
    case "企业":
      result = i18n.t('personal_lang1.Organization');
      break;
    case "自然人":
      result = i18n.t('personal_lang1.Individual');
      break;
    case "商标续展":
      result = i18n.t('translate_FE_lang.linshi1');
      break;
    case "注册性分析":
    case "可注性分析":
    case "可注册性分析":
      result = i18n.t('follow_up_FE_lang.Analysis_of_trademark');
      break;
    case "中国大陆商标注册":
      result = i18n.t('translate_FE_lang.linshi2');
      break;
    case "中国香港商标注册":
      result = i18n.t('translate_FE_lang.linshi3');
      break;
    case "查询成功":
      result = i18n.t('query_lang.Search_successful');
      break;
    case "预定续展":
      result = i18n.t('follow_up_FE_lang.Schedule_renewal');
      break;
    case "正常续展":
      result = i18n.t('follow_up_FE_lang.Renewal');
      break;
    case "宽展期续展":
      result = i18n.t('follow_up_FE_lang.Extension_renewal');
      break;
    case "不可续展":
      result = i18n.t('follow_up_FE_lang.Unable_to_renew');
      break;
    case "实收金额":
      result = i18n.t('follow_up_FE_lang.Amount_paid');
      break;
    case "颜色组合"://对应bug1682
      result = "Color mark";
      break;
    case "三维标志"://对应bug1682
      result = "3D mark";
      break;
    case "立体商标"://对应bug1682
      result = "3D mark";
      break;
    case "声音商标"://对应bug1682
      result = "Sound Mark";
      break;
    case "图形"://对应bug1682
      result = "Design";
      break;
    case "指定颜色"://对应bug1682
      result = "Claiming color protection";
      break;
    default:
      result = str;
  }
  return result;
};
/**
 存储订单状态
 **/
export const setOrderStatus = function (orderId, status) {
  let localStatus = getLocal("orderStaus") ? getLocal("orderStau s") : {};
  let orderStaus = Object.assign(localStatus, {
    [orderId]: status
  });
  setLocal("orderStaus", orderStaus);
};
export const setOrderStatus2 = () => {
  console.log(5, "setOrderStatus2");
};
/**
 分页国际化
 **/
export const paginationEn = function () {
  /*分页国际化;*/
  if (this.$i18n.locale == 'en-US') {
    this.$nextTick(() => {
      /*共多少条*/
      /*      let text = $(".el-pagination__total").html();//共 3147 条
            text = text.replace("共", "");
            text = text.replace("条", '<span style="color: #454545;font-size: 14px;">results</span>');
            $(".el-pagination__total").html(text);*/
      /*前往*/
      $(".go-to-page-l").remove();
      $(".el-input.el-pagination__editor.is-in-pagination").before('<span class="go-to-page-l" style="color: #454545;font-size: 14px;">Go to page </span>');
    })
  }
};
//马丹丹分页
export const pagingnEn = function () {
  /*分页国际化;*/
  if (this.$i18n.locale == 'en-US') {
    this.$nextTick(() => {
      $(".go-to-page-l").remove();
      $(".el-input.el-pagination__editor.is-in-pagination").before('<span class="go-to-page-l" style="color: #454545;font-size: 14px;">Go to page </span>');
    })
  }
};
/**
 货币符号
 **/
export const currencySymbol = function (currency) {
  let obj = {
    CNY: "RMB¥",
    USD: "$",
    EUR: "€",
    /*    GBP:"£",
        CAD:"Can$",
        JPY:"JPY¥",
        AUD:"$A",
        HKD:"HK$",
        CHF:"SF",*/
  };
  if (obj[currency] != undefined) return obj[currency];
  else return currency;
};
/**
 全角转半角
 **/
export const ToCDB = function (str) {
  let tmp = "";
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 65248 && str.charCodeAt(i) < 65375) {
      tmp += String.fromCharCode(str.charCodeAt(i) - 65248);
    }
    else {
      tmp += String.fromCharCode(str.charCodeAt(i));
    }
  }
  return tmp
};


export const aesjsHappy = function (str, decryption) {
  let key = [19, 5, 2, 5, 4, 2, 6, 8, 2, 4, 2, 0, 2, 0, 5, 5];
  let text = str;
  if (!decryption) {
    let textBytes = aesjs.utils.utf8.toBytes(text);
    let aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(5));
    let encryptedBytes = aesCtr.encrypt(textBytes);
    let encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);
    console.log(encryptedHex);
  } else {
    let encryptedBytes = aesjs.utils.hex.toBytes(text);
    let aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(5));
    let decryptedBytes = aesCtr.decrypt(encryptedBytes);
    let decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
    console.log(decryptedText);
  }
};

/**
 this.domToBase64($(".preview")[0])
 .then((data)=>{
            console.log(data.src);
          })
 .catch((e)=>{
            console.log(e);
          });
 **/

export const domToBase64 = function (who) {
  let shareContent = who;
  let width = shareContent.offsetWidth;
  let height = shareContent.offsetHeight;
  let canvas = document.createElement("canvas");
  let scale = 2;
  canvas.width = width * scale;
  canvas.height = height * scale;
  canvas.getContext("2d").scale(scale, scale);
  let opts = {
    scale: scale,
    canvas: canvas,
    logging: false,
    width: width,
    height: height,
    useCORS: true,//别忘记提醒老汤设置图片配置CORS,给上传的图片设置即可;
  };
  return new Promise((resolve,reject)=>{
    html2canvas(shareContent, opts)
      .then(canvas => {
        let context = canvas.getContext('2d');
        context.mozImageSmoothingEnabled = false;
        context.webkitImageSmoothingEnabled = false;
        context.msImageSmoothingEnabled = false;
        context.imageSmoothingEnabled = false;
        let a=Canvas2Image.convertToImage(canvas, canvas.width, canvas.height);
        resolve(a);
      })
      .catch((e) => {
        reject(e);
      })
  });

};
/**
 * 浏览器版本检测
 */
/*alert("浏览器:" + getBroswer().broswer + "\n 版本:" + getBroswer().version);*/
export const getBroswer = function () {
  var sys = {};
  var ua = navigator.userAgent.toLowerCase();
  var s;
  (s = ua.match(/edge\/([\d.]+)/)) ? sys.edge = s[1] :
    (s = ua.match(/rv:([\d.]+)\) like gecko/)) ? sys.ie = s[1] :
      (s = ua.match(/msie ([\d.]+)/)) ? sys.ie = s[1] :
        (s = ua.match(/firefox\/([\d.]+)/)) ? sys.firefox = s[1] :
          (s = ua.match(/chrome\/([\d.]+)/)) ? sys.chrome = s[1] :
            (s = ua.match(/opera.([\d.]+)/)) ? sys.opera = s[1] :
              (s = ua.match(/version\/([\d.]+).*safari/)) ? sys.safari = s[1] : 0;

  if (sys.edge) return { broswer : "Edge", version : sys.edge };
  if (sys.ie) return { broswer : "IE", version : sys.ie };
  if (sys.firefox) return { broswer : "Firefox", version : sys.firefox };
  if (sys.chrome) return { broswer : "Chrome", version : sys.chrome };
  if (sys.opera) return { broswer : "Opera", version : sys.opera };
  if (sys.safari) return { broswer : "Safari", version : sys.safari };

  return { broswer : "", version : "0" };
};
/**
 * 系统检测
 */
export const getOsInfo = function () {
  var userAgent = navigator.userAgent.toLowerCase();
  var name = 'Unknown';
  var version = "Unknown";
  if(userAgent.indexOf("win") > -1) {
    name = "Windows";
    if(userAgent.indexOf("windows nt 5.0") > -1) {
      version = "Windows 2000";
    } else if(userAgent.indexOf("windows nt 5.1") > -1 || userAgent.indexOf("windows nt 5.2") > -1) {
      version = "Windows XP";
    } else if(userAgent.indexOf("windows nt 6.0") > -1) {
      version = "Windows Vista";
    } else if(userAgent.indexOf("windows nt 6.1") > -1 || userAgent.indexOf("windows 7") > -1) {
      version = "Windows 7";
    } else if(userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows 8") > -1) {
      version = "Windows 8";
    } else if(userAgent.indexOf("windows nt 6.3") > -1) {
      version = "Windows 8.1";
    } else if(userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows nt 10.0") > -1) {
      version = "Windows 10";
    } else {
      version = "Unknown";
    }
  } else if(userAgent.indexOf("iphone") > -1) {
    name = "Iphone";
  } else if(userAgent.indexOf("mac") > -1) {
    name = "Mac";
  } else if(userAgent.indexOf("x11") > -1 || userAgent.indexOf("unix") > -1 || userAgent.indexOf("sunname") > -1 || userAgent.indexOf("bsd") > -1) {
    name = "Unix";
  } else if(userAgent.indexOf("linux") > -1) {
    if(userAgent.indexOf("android") > -1) {
      name = "Android"
    } else {
      name = "Linux";
    }

  } else {
    name = "Unknown";
  }
  var os = new Object();
  os.name =  name;
  os.version = version;
  return os;
  //document.write("系统：" + os.name + "版本:" + os.version)
};

/**
 * 输入校验
 */
export const inputCheckout = function (obj) {
  i18n.locale = JSON.parse(window.localStorage.lang).lang;//再来一下,才稳定
  let bol = false;
  switch (obj.who) {
    case 'enApplicant': {
      if (obj.val != '' && !this.isInputEn(obj.val)) {
        bol = false;
      }
      else {
        bol = true;
      }
      if (!bol && obj.msg) {
        this.$message('书式类型为国外时必须输入英文名称');
      }
      break;
    }
    case 'enAddress': {
      if (obj.val != '' && !this.isInputEn(obj.val)) {
        bol = false;
      }
      else {
        bol = true;
      }
      if (!bol && obj.msg) {
        this.$message('书式类型为国外时必须输入英文详细地址');
      }
      break;
    }
    case 'cnApplicant': {
      var arr = new Array();
      arr = obj.val.split(" ");
      bol = true;
      if (arr.length != 1) {
        bol = false;
      }
      if (!bol && obj.msg) {
        this.$message('申请人名称不能有空格、只能是汉字，申请人是企业时必须大于等于1个汉字');
      }
      break;
    }
    case 'cnAddress': {
      if (this.fomat_qh(obj.val)) {
        bol = true;
      } else {
        bol = false;
      }
      break;
    }
    case 'number': {
      let reg = /^[0-9A-Za-z]+$/;
      bol = reg.test(obj.val);
      if (!bol && obj.msg) {
        // Message(i18n.t('follow_up_FE_lang.Cannot_contain_special_characters'));//只能数字字母
      }
      break;
    }
    case 'teshu': {
      let reg = /^[\u0391-\uFFE5A-Za-z0-9\s\+]+$/;
      bol = reg.test(obj.val);
      if (!bol && obj.msg) {
        Message(i18n.t('follow_up_FE_lang.Cannot_contain_special_characters'));//不能包含特殊字符
      }
      break;
    }
    case 'enterpriseCredit': {
      let reg1 = /^[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}$/;
      let reg2 = /^[1-9A-GY]{1}[1239]{1}[1-5]{1}[0-9]{5}[0-9A-Z]{10}$/;
      bol = reg1.test(obj.val) || reg2.test(obj.val);
      if (!bol && obj.msg) {
        Message(i18n.t('reg_query_lang.Social_unified_coding'));//请输入正确的社会统一编码
      }
      break;
    }
    case 'email': {
      bol = /^[_a-zA-Z0-9\-\.]+@([\-_a-zA-Z0-9]+\.)+[a-zA-Z0-9]{2,3}$/.test(obj.val);
      if (!bol && obj.msg) {
        this.$message("邮箱格式错误");
      }
      break
    }
    case 'telephone': {//固定电话
      bol = /^(\d{3,4}-?)?\d{7,9}$/g.test(obj.val);
      if (!bol && obj.msg) {
        this.$message("电话格式错误");
        return;
      }
      break
    }
    case 'cellphone': {//手机
      bol = /^(((13[0-9]{1})|(15[0-35-9]{1})|(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/.test(obj.val);
      if (!bol && obj.msg) {
        this.$message("手机格式错误");
        return;
      }
      break
    }
    case 'QQ': {//QQ
      bol = /^[1-9]\d{4,12}/.test(obj.val);
      if (!bol && obj.msg) {
        this.$message("QQ格式错误");
        return;
      }
      break
    }
    case 'zipCode': {
      if(!obj.val&& obj.msg){//0628添加
        this.$message("请输入邮编");
        return;
      }
      bol = /^[0-9]{6}$/.test(obj.val);
      if (!bol && obj.msg) {
        this.$message("邮编格式错误");//不用翻译
      }
      break
    }
    case 'phone': {
      if(!obj.val&& obj.msg){//0628添加
        this.$message("请输入联系电话");
        return;
      }
      let telephone = /^(\d{3,4}-?)?\d{7,9}$/g;
      let cellPhone = /^(((13[0-9]{1})|(15[0-35-9]{1})||(17[0-9]{1})|(18[0-9]{1}))+\d{8})$/;
      bol = telephone.test(obj.val) || cellPhone.test(obj.val);
      if (!bol && obj.msg) {
        this.$message("电话号码格式错误");//不用翻译
      }
      break
    }
    case 'idCard': {
      let reg1 = /^(\d{6})()?(\d{2})(\d{2})(\d{2})(\d{2})(\w)$/;
      let reg2 = /^(\d{6})()?(\d{4})(\d{2})(\d{2})(\d{3})(\w)$/;
      bol = reg1.test(obj.val) || reg2.test(obj.val);
      if (!bol && obj.msg) {
        this.$message(this.$t('reg_query_lang.Certificate_number_format_error'));//证件号码格式错误
      }
      break
    }
    case 'passport': {
      let reg = /^1[45][0-9]{7}|([P|p|S|s]\d{7})|([S|s|G|g]\d{8})|([Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8})|([H|h|M|m]\d{8，10})$/;
      bol = reg.test(obj.val);
      if (!bol && obj.msg) {
        this.$message(this.$t('reg_query_lang.Certificate_number_format_error'));//证件号码格式错误
      }
      break
    }
  }
  return bol;
};
/**
 * 来自appUtils.js,用于输入校验
 */
export const isInputEn = function (str) {
  var strSource = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789,./\?;:'!<>{}[]+《》、-()@%&*＇。（）~- ：.\"’“”#";
  var ch;
  var i;
  var temp;
  var flag = true;
  if (str.length == 0) {
    flag = false;
  }
  else {
    for (i = 0; i <= (str.length); i++) {
      ch = str.charAt(i);
      temp = strSource.indexOf(ch);
      if (ch != ' ' && temp == -1) {
        flag = false;
      }
    }
  }

  return flag;
}

export const fomat_qh = function (quhua) {
  return true;//英文版,直接返回true;
  var addr = quhua.toString();
  var s = document.getElementById("appGjdq");
  if (null == s || undefined == s) {
    //console.log("获取国籍内容失败,请检查国籍命名");
    return false;
  }
  if (undefined == s.options || null == s.options[s.selectedIndex]) {
    //console.log("中文地址栏已被锁住无法修改");
    return true;
  }
  var a = s.options[s.selectedIndex].innerText;
  var reFlag;
  if (a.indexOf('国外') != -1) {//是国外
    reFlag = true;
  } else {
    if (addr.indexOf("(") > -1) {
      addr = addr.replace("(", "（");
    }
    if (addr.indexOf(")") > -1) {
      addr = addr.replace(")", "）");
    }
    var ary = new Array('北京市', '天津市', '河北省', '山西省', '内蒙古自治区', '内蒙古省', '辽宁省', '吉林省', '黑龙江省', '上海市', '江苏省', '浙江省', '安徽省', '福建省', '江西省', '山东省', '河南省', '湖北省', '湖南省', '广东省', '广西壮族自治区', '广西省', '海南省', '重庆市', '四川省', '贵州省', '云南省', '西藏自治区', '西藏省', '陕西省', '甘肃省', '青海省', '宁夏回族自治区',
      '宁夏省', '新疆维吾尔自治区', '新疆省', '香港特别行政区', '香港', '中国香港', '澳门特别行政区', '中国澳门', '澳门', '台湾省', '中国台湾', '台湾', '新疆生产建设兵团', '中国（上海）自由贸易试验区', '中国（广东）自由贸易试验区', '中国（天津）自由贸易试验区', '中国（福建）自由贸易试验区', '中国（辽宁）自由贸易试验区', '中国（浙江）自由贸易试验区', '中国（河南）自由贸易试验区', '中国（湖北）自由贸易试验区', '中国（重庆）自由贸易试验区', '中国（四川）自由贸易试验区', '中国（陕西）自由贸易试验区');
    reFlag = false;
    for (var i = 0; i < ary.length; i++) {
      if (addr.indexOf(ary[i]) > -1) {
        reFlag = true;
        break;
      }
    }
  }
  return reFlag;
};




// WEBPACK FOOTER //
// ./src/config/utils.js